<template>
  <base-modal
    ref="$modal"
    :loading="isLoading"
    width="900px"
    height="800px"
    @on-close="isActive = false"
  >
    <div class="permitions">
      <analytic-permitions-tab
        :container="rulesContainer"
        :entity-ids="entitiesIdRef"
        :can-edit="true"
        @save="onSave"
        @cancel="onClose"
        :type="entitiesType === PROJECT_SEGMENT ? 'project' : 'client'"
      />
    </div>
  </base-modal>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import moment from "moment";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppLists from "@/components/ui-kit/lists/AppLists.vue";
import { CommonEntityRecord } from "@/models/interfaces/common";
// import ProjectAccessRulesTab from "../permitions/ProjectAccessRulesTab.vue";
import AnalyticPermitionsTab from "./AnalyticPermitionsTab.vue";
import { EntityRulesContainer } from "@/models/interfaces/access/entity-rules";
import { AccessApi } from "@/ api/AccessApi";

const PROJECT_SEGMENT = 0;

const emit = defineEmits<{
  (e: "saved"): void;
}>();

const route = useRoute();

const $modal = ref<typeof BaseModal | null>(null);
const isActive = ref(false);
const $lists = ref<InstanceType<typeof AppLists> | null>(null);

const rulesContainer = ref<EntityRulesContainer | null>(null);

const activeTab = ref<number>(0);
const isLoading = ref(false);
const entitiesIdRef = ref<number[]>([]);
const entitiesType = ref<number>(0);
const tags = ref<CommonEntityRecord[]>([]);

const formatDate = (date: string | undefined | null) => {
  if (!date) return "";
  return moment(date).format("HH:mm DD.MM.YYYY");
};

watch(activeTab, () => {
  $lists.value?.close();
});

const onOpen = async (selectedIds: number[], destType: number) => {
  try {
    entitiesIdRef.value = selectedIds;
    entitiesType.value = destType
    // clientIdRef.value = projectId;
    isLoading.value = true;
    activeTab.value = 0;
    $modal.value?.onOpen();
    isActive.value = true;
    await refreshRules();
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const onClose = () => {
  isActive.value = false;
  $modal.value?.onClose();
};

const onSave = () => {
  emit("saved");
  onClose();
};

onMounted(() => {
  window.addEventListener("keydown", handleEsc, true);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEsc, true);
});

const handleEsc = async (e: KeyboardEvent) => {
  if (e.key !== "Escape") {
    return;
  }
  if (document.querySelector('.app-select__dropdown')) {
    return;
  }
  if (!isActive.value) {
    return;
  }

  e.stopPropagation();
  $modal.value?.onClose();
};

// watch(projectPage.project?.RuleAccess,() => { if(projectPage.project?.RuleAccess ==1) tabs.value = [
//   { id: 0, title: "Информация о проекте", slotName: "info" },
//   { id: 1, title: "Права доступа", slotName: "rules" },
// ];})

defineExpose({ onOpen });

const refreshRules = async () => {
  try {
    const rulesGiver =
      entitiesType.value === PROJECT_SEGMENT
        ? await AccessApi.getProjectAccessRules(entitiesIdRef.value[0])
        : await AccessApi.getClientAccessRules(entitiesIdRef.value[0]);
    rulesContainer.value = rulesGiver?.Container ?? null;
  } catch (e) {
    console.error(e);
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/color.scss";

:deep(.app-tabs) {
  overflow: hidden;
}

:deep(.app-tabs__content) {
  overflow: hidden;
}

:deep(.app-tabs__content-tab) {
  overflow-y: auto;
}

.project-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px 16px;

  &__header {
    display: flex;
    align-items: stretch;
    width: 100%;
    gap: 8px;

    &-left,
    &-right {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    &-left {
      flex: 2;
    }
    &-right {
      flex: 1;
    }
  }

  &__records {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__field {
    margin-bottom: 4px;
    font-size: 14px;
    line-height: 18px;
    overflow-wrap: anywhere;
    word-break: break-word;

    &--col {
      display: flex;
      flex-direction: column;
    }

    &-name {
      color: $color-text_main;
      font-weight: 500;
    }

    &-value {
      color: $color-text_main;
    }

    &-value-col {
      display: inline-block;
      overflow-wrap: anywhere;
      word-break: break-word;

      &-time {
        color: #979797;
      }

      &-name {
        color: $color-text_main;
      }

      &-action {
        margin-left: 2px;
        color: $color-text_main;
      }

      &-person {
        color: $color-text_main;
        font-style: italic;
      }

      &-link {
        color: #396742;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.permitions {
  display: flex;
  height: 100%;
  flex-direction: column;
}
</style>
